import Market from '../model/Market'
import { configuration } from './Configuration'
import { fetchWithAccessToken } from './SiteConfig-api'

export const loadMarketList = (): Promise<Market[]> => loadMarketListFromURL(`${configuration.SmartAPI}markets`)

const loadMarketListFromURL = (url: string): Promise<Market[]> => {
  return fetchWithAccessToken(url, 'SmartApi', {
    method: 'GET',
    credentials: 'include'
  }).then(function(response: Response) {
    if (response.status !== 200) {
      throw response.statusText
    }
    // Convert to JSON
    return response.text().then(json => JSON.parse(json))
  })
}
